import React from 'react';
type StarsProps = {
  className?: string;
};
export function Stars({
  className = 'text-base'
}: StarsProps) {
  return <span className={className} role="img" aria-label="5 out of 5 stars" data-id="element-269" data-mp="3gpcmq0a44yzt">
      ⭐⭐⭐⭐⭐
    </span>;
}